import { render, staticRenderFns } from "./shiliuqiang.vue?vue&type=template&id=ad148d6c&scoped=true&"
import script from "./shiliuqiang.vue?vue&type=script&lang=ts&"
export * from "./shiliuqiang.vue?vue&type=script&lang=ts&"
import style0 from "./shiliuqiang.vue?vue&type=style&index=0&id=ad148d6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad148d6c",
  null
  
)

export default component.exports